import { render, staticRenderFns } from "./data-read-list.vue?vue&type=template&id=17954812"
import script from "./data-read-list.vue?vue&type=script&lang=js"
export * from "./data-read-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports